import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette, breakpoints }) => ({
  fieldList: {
    display: 'grid',
    gap: spacing(24),
  },
  deleteButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '-18px',
    paddingTop: '14px',
  },
  deleteButton: {
    padding: spacing(8),
    minWidth: '36px',
  },
  fullWidth: {
    width: '100%',
  },
  label: {
    marginTop: '10px',
    fontSize: Theme.Typography.FontSize.Tiny,
    color: Theme.Colors.Grayscale.ThirtyTwo,
  },
  providerSelectWrapper: {
    position: 'relative',
    width: '100%',
  },
  providerSelectWrapperWithError: {
    position: 'relative',
    width: '100%',
    paddingBottom: spacing(20),
  },
  duplicateProviderError: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    margin: 0,
    fontSize: Theme.Typography.FontSize.Tiny,
    lineHeight: 1.66,
  },
  selectWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: props => {
      if (props?.poolAvailable) {
        return props?.multipleTradesman ? '81%' : '85%'
      }

      return props?.multipleTradesman ? '94%' : '85%'
    },
    marginTop: '20px',
    padding: '0px 8px 0 50px',
    flex: props => {
      if (props?.poolAvailable) {
        if (!props?.multipleTradesman) return 1
        return 'unset'
      }
      return props?.multipleTradesman ? 'unset' : 1
    },
    paddingRight: props => {
      if (props?.poolAvailable) {
        return props?.multipleTradesman ? '10px' : '8px'
      }
      return props?.multipleTradesman ? '8px' : 0
    },
    marginBottom: spacing(16),
  },
  selectWrapperWithPool: {
    width: '85%',
    padding: '0px 28px 0 50px',
  },
  roundLabel: {
    fontSize: `${Theme.Typography.FontSize.Tiny} !important`,
    color: `${Theme.Colors.Grayscale.ThirtyTwo} !important`,
  },
  select: {
    width: '100%',
  },
  selectLabel: {
    fontWeight: '400',
    width: '100%',
  },
  showReferaSuggestions: {
    margin: '0 0 16px',
  },
  runPool: {
    alignSelf: 'center',
  },
  descriptionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing(16),
  },
  clearProvidersTooltipWrap: {
    display: 'inline-flex',
  },
  clearProvidersButton: {
    color: Theme.Colors.Red.Base,
    padding: '4px 8px',
    minHeight: 'unset',
    whiteSpace: 'nowrap',
  },
  sendRequesterMessage: {
    margin: 0,

    '& .ReferaSwitch__Label': {
      display: 'none !important',
    },
  },
  actions: {
    flexDirection: 'row !important',
    justifyContent: 'space-between !important',
    alignItems: 'flex-end !important',
    gap: `${spacing(16)} !important`,

    [breakpoints.down('xs')]: {
      flexDirection: 'column !important',
      alignItems: 'stretch !important',
    },
  },
  requesterMessageAction: {
    minWidth: '220px',

    [breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  sendRequesterMessageHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(4),
    marginBottom: spacing(6),
  },
  sendRequesterMessageLabel: {
    color: palette.gray[64],
    fontSize: spacing(12),
    lineHeight: spacing(16),
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: spacing(12),

    '& button': {
      padding: `${spacing(8, 16)} !important`,
      width: `${spacing(120)} !important`,
    },

    [breakpoints.down('xs')]: {
      width: '100%',
      flexDirection: 'column',

      '& button': {
        padding: `${spacing(16)} !important`,
        width: '100% !important',
      },
    },
  },
  customSelectLabel: {
    color: '#B4B4B4',
    fontSize: '12px',
    marginTop: '14px !important',
    marginBottom: '-8px !important',
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  customSelect: {
    width: props => {
      if (props?.poolAvailable) {
        return props?.multipleTradesman ? '36px' : '46px'
      }

      return props?.multipleTradesman ? '36px' : '46px'
    },
  },
  modalContent: {
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    gap: spacing(16),
    padding: `${spacing(20)} !important`,
  },
  addProviderContainer: {
    marginTop: spacing(16),
  },
  tooltip: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: palette.primary.main,
      color: palette.gray[4],
    },
    '& .MuiTooltip-arrow': {
      color: palette.primary.main,
    },
  },
  tooltipBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  li: {
    width: '100%',
  },
  svgIcon: {
    width: '40px',
    height: '40px',
  },
}))
